const root = '/events';
const baseRoute = (path = '') => `${root}${path}`;

export default {
  root,
  viewLog: baseRoute(),
  details: (id: string | number = ':eventId') => baseRoute(`/${id}`),
} as const;
